import { render, staticRenderFns } from "./stacked.vue?vue&type=template&id=2e5cf0cc&scoped=true&"
import script from "./stacked.vue?vue&type=script&lang=js&"
export * from "./stacked.vue?vue&type=script&lang=js&"
import style0 from "./stacked.vue?vue&type=style&index=0&id=2e5cf0cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5cf0cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
